/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemRecipientType } from './MailboxItemRecipientType';
import {
    MailboxItemRecipientTypeFromJSON,
    MailboxItemRecipientTypeFromJSONTyped,
    MailboxItemRecipientTypeToJSON,
    MailboxItemRecipientTypeToJSONTyped,
} from './MailboxItemRecipientType';

/**
 * 
 * @export
 * @interface MailboxRecipientDTO
 */
export interface MailboxRecipientDTO {
    /**
     * 
     * @type {MailboxItemRecipientType}
     * @memberof MailboxRecipientDTO
     */
    Type?: MailboxItemRecipientType;
    /**
     * 
     * @type {string}
     * @memberof MailboxRecipientDTO
     */
    Address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MailboxRecipientDTO
     */
    DisplayName?: string | null;
}



/**
 * Check if a given object implements the MailboxRecipientDTO interface.
 */
export function instanceOfMailboxRecipientDTO(value: object): value is MailboxRecipientDTO {
    return true;
}

export function MailboxRecipientDTOFromJSON(json: any): MailboxRecipientDTO {
    return MailboxRecipientDTOFromJSONTyped(json, false);
}

export function MailboxRecipientDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxRecipientDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Type': json['Type'] == null ? undefined : MailboxItemRecipientTypeFromJSON(json['Type']),
        'Address': json['Address'] == null ? undefined : json['Address'],
        'DisplayName': json['DisplayName'] == null ? undefined : json['DisplayName'],
    };
}

export function MailboxRecipientDTOToJSON(json: any): MailboxRecipientDTO {
    return MailboxRecipientDTOToJSONTyped(json, false);
}

export function MailboxRecipientDTOToJSONTyped(value?: MailboxRecipientDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Type': MailboxItemRecipientTypeToJSON(value['Type']),
        'Address': value['Address'],
        'DisplayName': value['DisplayName'],
    };
}

